import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { ModalService } from '../../services/modal.service';
import { ConfirmationDialogService } from '../confirmation-dialog/confirmation-dialog.service';
import { ConfPainel } from '../../model/confpainelmap';
import { CadastrosService } from '../../services/cadastros.service';

@Component({
  selector: 'app-confpainel',
  templateUrl: './confpainel.component.html',
  styleUrls: ['./confpainel.component.scss']
})
export class ConfPainelComponent implements OnInit {

  movSub: Subscription;
  confpainel: any[];
  fileReader: FileReader;
  fileToRead: File;

  constructor(
      private spinner: NgxSpinnerService,
      private modalService: ModalService,
      private cadastrosService: CadastrosService,
      private toastr: ToastrService,
      private confirmationDialogService: ConfirmationDialogService
  ){

  }

  ngOnInit() {
    this.getConfPainels();
  }

  async getConfPainels(){

    this.confpainel = [];

    if (this.movSub && this.movSub.closed == false){
      this.movSub.unsubscribe();
    }

    if (!this.movSub || this.movSub.closed){

      this.spinner.show();

      this.movSub = this.cadastrosService.listar("confpainel/list").subscribe(
        (result: any) =>{

          this.confpainel =  result;
          console.log(result);

          this.spinner.hide();

       },error=>{
            console.log(error);
            this.spinner.hide();
       });

    }


  }

  ngOnDestroy(){
    if (this.movSub && this.movSub.closed == false){
      this.movSub.unsubscribe();
    }
  }

  novoConfPainel(){
    this.modalService.modalDetalhesConfPainel.emit(null);
  }

  editar(confpainel: ConfPainel){
    this.modalService.modalDetalhesConfPainel.emit(confpainel);
  }

  excluir(confpainel: ConfPainel){

    this.confirmationDialogService.confirm('Confirmar?', 'Realmente deseja excluir ?')
      .then((confirmed) =>{

        if(confirmed){
          this.cadastrosService.excluir("confpainel/delete", confpainel).subscribe(
            (result) =>{

              this.toastr.success('Configuração excluída com sucesso!', 'Sucesso!');
              this.getConfPainels();
              console.log(result);

            },
            error=> {

              this.toastr.error(error.message, 'Erro!');
              console.log(error);

            }
          );
        }

      })
      .catch(() => {
        console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)')
      });

  }

}
